import React from "react";
import "./Contactheader.css";

/**
 * Props:
 *  - bgSrc    : string  -> image path or imported asset
 *  - focusY   : number  -> vertical focus in %, default 35 (shows faces)
 *  - darkness : number  -> 0..1 overlay strength, default 0.45
 *
 * Usage with /public:
 *  <ContactHeader bgSrc="/images/contact-header.webp" />
 *
 * Usage with imported asset:
 *  import hero from "../../assets/contact-header.webp";
 *  <ContactHeader bgSrc={hero} />
 */
export default function ContactHeader({ bgSrc, focusY = 25, darkness = 0.45 }) {
  const fallback = `${process.env.PUBLIC_URL || ""}/contact.webp`;
  const bgUrl = bgSrc || fallback;

  return (
    <section
      className="contact-header"
      style={{
        "--contact-bg": `url("${bgUrl}")`,
        "--focus-y": `${focusY}%`,
        "--overlay": darkness
      }}
      aria-label="Contact page header"
    >
      <div className="contact-header__overlay" aria-hidden="true" />
      <div className="contact-header__content">
        <h1 className="contact-header__title">Frame Your Moments</h1>
        <span className="contact-header__underline" aria-hidden="true" />
      </div>
    </section>
  );
}

